import { render } from "./SVGWhatsApp.vue?vue&type=template&id=6916ed4b"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/svg/SVGWhatsApp.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6916ed4b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6916ed4b', __exports__)) {
    api.reload('6916ed4b', __exports__)
  }
  
  module.hot.accept("./SVGWhatsApp.vue?vue&type=template&id=6916ed4b", () => {
    api.rerender('6916ed4b', render)
  })

}


export default __exports__